import { motion } from 'framer-motion';
import VideoCard from './VideoCard';
import { staggerContainer, staggerItem } from '../../utils/animations';

const VideoGrid = ({ videos, onVideoSelect }) => {
  if (!videos || videos.length === 0) {
    return (
      <div className="text-center py-20">
        <div className="text-8xl mb-4">🎬</div>
        <h3 className="text-2xl font-display font-bold text-primary-green-dark mb-2">
          No videos available
        </h3>
        <p className="text-neutral-gray-dark">
          Check back soon for new content!
        </p>
      </div>
    );
  }

  return (
    <motion.div
      variants={staggerContainer}
      initial="initial"
      whileInView="animate"
      viewport={{ once: true }}
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto"
    >
      {videos.map((video) => (
        <motion.div
          key={video.id}
          variants={staggerItem}
        >
          <VideoCard
            video={video}
            onClick={() => onVideoSelect(video)}
          />
        </motion.div>
      ))}
    </motion.div>
  );
};

export default VideoGrid;